/**
 * Vendor Master seed — agencies / vendors (UI mock).
 * Aligns with Utkarsh-mobile vendor signup (Business → Owner → Location → KYC).
 */

export const CONSTITUTION_OPTIONS = [
  'Proprietorship',
  'Partnership',
  'Private Limited',
];

export const VENDOR_VERIFICATION_STATUSES = ['Verified', 'Pending', 'Rejected', 'Blocked'];

export const VENDOR_VERIFICATION_OPTIONS = VENDOR_VERIFICATION_STATUSES.map((s) => ({
  value: s,
  label: s,
}));

/** Excel M_Vendor Master — LOCAL/PROFESSIONAL */
export const LOCAL_PROFESSIONAL_OPTIONS = [
  { value: 'LOCAL', label: 'LOCAL' },
  { value: 'PROFESSIONAL', label: 'PROFESSIONAL' },
];

/** Excel M_Vendor Master — Major Category */
export const MAJOR_CATEGORY_OPTIONS = [
  { value: 'SERVICE', label: 'SERVICE' },
  { value: 'TRADER', label: 'TRADER' },
];

function mockFile(fileName) {
  return { name: fileName, fileName, url: null, kind: 'image' };
}

export const vendorMasterSeed = [
  {
    vendorId: 'VND-001',
    gstNumber: '24AABCU9603R1ZM',
    tradeAgencyName: 'Mundra Earth Movers',
    constitution: 'Proprietorship',
    dateOfIncorporation: '2018-04-12',
    ownerName: 'Hitesh',
    fatherHusbandName: 'Kanji',
    surname: 'Chauhan',
    ownerFullName: 'Hitesh Kanji Chauhan',
    mobile: '9876112233',
    email: 'hitesh@mundraearth.example',
    address1: 'Plot 12, Industrial Area',
    address2: '',
    villageId: 'V-MUN-002',
    pin: '370421',
    buId: 'BU-APMUL',
    siteId: 'ST-MSPVL',
    kronosNumber: 'AK-88421',
    localProfessional: 'LOCAL',
    majorCategory: 'SERVICE',
    photo: null,
    aadhaarNumber: 'XXXX-XXXX-4412',
    pan: 'ABCDE1234F',
    gstCertificate: mockFile('vnd001_gst_certificate.jpg'),
    businessOfficePhoto: mockFile('vnd001_office.jpg'),
    aadhaarFront: mockFile('vnd001_aadhaar_front.jpg'),
    aadhaarBack: mockFile('vnd001_aadhaar_back.jpg'),
    panCard: mockFile('vnd001_pan.jpg'),
    verificationStatus: 'Verified',
    rejectionReason: '',
    blockReason: '',
    portalToken: 'vt-demo001mundra',
    portalTokenIssuedAt: '2026-08-01T09:00:00',
    active: true,
  },
  {
    vendorId: 'VND-002',
    gstNumber: '24AAACW1234A1Z5',
    tradeAgencyName: 'Kutch Hire Services',
    constitution: 'Partnership',
    dateOfIncorporation: '2015-09-01',
    ownerName: 'Prakash',
    fatherHusbandName: 'Shantilal',
    surname: 'Shah',
    ownerFullName: 'Prakash Shantilal Shah',
    mobile: '9825012345',
    email: 'ops@kutchhire.example',
    address1: '99/2, Sanskar Nagar Old',
    address2: 'Nr. Garbi Chowk',
    villageId: 'V-MUN-059',
    pin: '370421',
    buId: 'BU-MPL',
    siteId: 'ST-MPL-P1',
    kronosNumber: 'AK-77210',
    localProfessional: 'LOCAL',
    majorCategory: 'TRADER',
    photo: null,
    aadhaarNumber: 'XXXX-XXXX-7788',
    pan: '',
    gstCertificate: mockFile('vnd002_gst_certificate.pdf'),
    businessOfficePhoto: mockFile('vnd002_office.jpg'),
    aadhaarFront: mockFile('vnd002_aadhaar_front.jpg'),
    aadhaarBack: null,
    panCard: null,
    verificationStatus: 'Pending',
    rejectionReason: '',
    blockReason: '',
    portalToken: '',
    portalTokenIssuedAt: '',
    active: true,
  },
  {
    vendorId: 'VND-003',
    gstNumber: '',
    tradeAgencyName: 'Baroi Transport Co.',
    constitution: 'Proprietorship',
    dateOfIncorporation: '2020-01-20',
    ownerName: 'Ashok',
    fatherHusbandName: 'Meghji',
    surname: 'Maheshwari',
    ownerFullName: 'Ashok Meghji Maheshwari',
    mobile: '9909901122',
    email: '',
    address1: 'Near Port Gate',
    address2: '',
    villageId: 'V-MUN-001',
    pin: '370421',
    buId: 'BU-PORT',
    siteId: 'ST-CT1',
    kronosNumber: '',
    localProfessional: 'PROFESSIONAL',
    majorCategory: 'SERVICE',
    photo: null,
    aadhaarNumber: '',
    pan: '',
    gstCertificate: null,
    businessOfficePhoto: null,
    aadhaarFront: null,
    aadhaarBack: null,
    panCard: null,
    verificationStatus: 'Rejected',
    rejectionReason: 'GST certificate and Aadhaar KYC not submitted.',
    blockReason: '',
    portalToken: '',
    portalTokenIssuedAt: '',
    active: false,
  },
];
